/* eslint-disable @typescript-eslint/no-explicit-any */
import { navigate } from 'gatsby'
import type { Facet } from '@faststore/sdk/dist/search/useSearchState'
import type { IStoreSelectedFacet } from '@faststore/api'
import { CloseButtonIcon } from 'src/components/Icons/CloseButtonIcon'
import { useSearch } from '@faststore/sdk'

interface SelectedFacetsProps {
  filteredFacets: IStoreSelectedFacet[]
  selectedFacets: IStoreSelectedFacet[]
  removeAllFacet: (item: any) => void
  removeFacet: (item: Facet) => void
}

interface RemoveFacetCustomProps {
  allFacets: IStoreSelectedFacet[]
  removalFunc: (item: any) => void
  typeOfRemoval: 'all' | 'single'
  singleFacet?: Facet
}

const navigateToCategory = (allFacets: any[], categoryKey: string) => {
  const category = allFacets.find((item) => item.key === categoryKey)?.value

  if (category) {
    navigate(`/${category}`)
  }
}

const handleFirstFacetRemoval = (allFacets: any[], singleFacet: any) => {
  const newUrl = window.location.pathname
  const newSearchParams = new URLSearchParams(window.location.search)
  const isUnique = allFacets.length === 1

  if (!isUnique) {
    const currentSelectedFacets = newSearchParams.getAll(
      newSearchParams.get('facets')?.split(',')[0] ?? ''
    )

    const toNavigate = `${newUrl}?${newSearchParams}`
      .toString()
      .replace(`&${singleFacet?.key}=${currentSelectedFacets[0]}`, '')

    navigate(toNavigate)

    return
  }

  isUnique && singleFacet?.key && newSearchParams.delete(singleFacet.key)
  isUnique && newSearchParams.delete('facets')
  navigate(`${newUrl}?${newSearchParams}`)
}

export const handleAllRemoval = (
  allFacets: any[],
  removalFunc: any,
  state: { base: string; term: string | null }
) => {
  removalFunc({ type: 'selectFacets', payload: [] })

  if (allFacets.some((item) => item.key === 'category-1')) {
    navigateToCategory(allFacets, 'category-1')

    return
  }

  if (state.term && !state.base.includes('/colecao')) {
    navigate(`${state.base}?q=${state.term}`)
  } else {
    navigate(state.base)
  }
}

const facetNamesMap = {
  'Iguasport LTDA': 'Cashback disponível',
}

const SelectedFacets = ({
  filteredFacets,
  selectedFacets,
  removeAllFacet,
  removeFacet,
}: SelectedFacetsProps) => {
  const {
    state: { base, term },
  } = useSearch()

  const removeFacetCustom = ({
    allFacets,
    removalFunc,
    typeOfRemoval,
    singleFacet,
  }: RemoveFacetCustomProps): void => {
    if (typeOfRemoval === 'all') {
      handleAllRemoval(allFacets, removalFunc, { base, term })

      return
    }

    if (typeOfRemoval === 'single') {
      if (singleFacet?.key === 'category-1' && allFacets.length === 2) {
        navigate(
          `/${allFacets.find((item) => item.key === 'category-1')?.value}`
        )

        return
      }

      if (singleFacet?.key === 'category-2') {
        const newUrl = window.location.href
          .replace(`${singleFacet.value}/`, '')
          .replace(`&category-2=${singleFacet.value}`, '')
          .replace('%2Ccategory-2', '')
          .split('/')
          .slice(3)
          .join('/')

        navigate(`/${newUrl}`)

        return
      }

      if (
        allFacets.findIndex((item) => item.value === singleFacet?.value) === 0
      ) {
        handleFirstFacetRemoval(allFacets, singleFacet)
      }
    }

    removalFunc(singleFacet)
  }

  return (
    <div
      className={`selected-filters mb-6 ${
        filteredFacets.length === 0 ? 'hidden' : ''
      }`}
    >
      <div className="flex gap-2 flex-wrap">
        {filteredFacets.length !== 0 &&
          filteredFacets.map((facet: any, idx) => {
            return (
              <div
                key={`${facet.value}-${idx}`}
                className="font-inter flex w-max gap-2 px-4 border border-restructure-border-chip rounded-round items-center h-12"
              >
                <p
                  className="text-black text-sm font-normal capitalize"
                  data-id={facet.key}
                >
                  {facetNamesMap[facet.label as keyof typeof facetNamesMap] ??
                    facet.label.replaceAll('-', ' ').toLowerCase()}
                </p>
                <button
                  aria-label="Remove Selected Filter"
                  onClick={() =>
                    removeFacetCustom({
                      allFacets: selectedFacets,
                      removalFunc: removeFacet,
                      typeOfRemoval: 'single',
                      singleFacet: facet,
                    })
                  }
                >
                  <CloseButtonIcon size={20} />
                </button>
              </div>
            )
          })}
      </div>
      <button
        className="text-neutral11 text-sm font-normal mt-4 underline underline-offset-4"
        onClick={() =>
          removeFacetCustom({
            allFacets: selectedFacets,
            removalFunc: removeAllFacet,
            typeOfRemoval: 'all',
          })
        }
      >
        Limpar filtros ({String(filteredFacets.length).padStart(2, '0')})
      </button>
    </div>
  )
}

export default SelectedFacets
